import React, { useCallback, useEffect, useState } from 'react'
import { Table } from 'reactstrap';
import { raiseClaimService } from '../../services';
import { formatDate } from '../../helpers/common';
import Loading from '../common/Loading';

const InfoRaiseClaimModal = ({ raiseClaimId, claimDetails }) => {
    const [remarksList, setRemarksList] = useState([])
    const [newComment, setNewComment] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const fetchRemarksHistoryList = useCallback(async () => {
        let payload = {
            parentId: raiseClaimId,
            purpose: "claim-policy",
            isOwnRemarks: false
        }
        setIsLoading(true)
        const claimResponse = await raiseClaimService.fetchRemarksHistory(payload)
        if (claimResponse?.data?.isSuccess) {
            setRemarksList(claimResponse.data.data)
        } else {
            setRemarksList([])
        }
        setIsLoading(false)
    }, [])

    const addComments = async () => {
        setIsSubmitted(true)
        let payload = { claimRaiseId: raiseClaimId, claimRemarks: newComment }
        const claimResponse = await raiseClaimService.addRemarks(payload)
        if (claimResponse?.data?.isSuccess) {
            fetchRemarksHistoryList()
            setNewComment('')
        }
        setIsSubmitted(false)
    }
    useEffect(() => {
        fetchRemarksHistoryList()
    }, [fetchRemarksHistoryList])

    return (
        !isLoading ?
            <div className='fieldArrayBox'>
                {remarksList?.length > 0 ?
                    <Table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Commenter</th>
                                <th>Role</th>
                                <th>Comments</th>
                            </tr>
                        </thead>
                        <tbody>
                            {remarksList?.map(({ raiseClaimRemarksId, remarks, remarksDate, remarksBy }) => {
                                const [commenter, role] = remarksBy ? remarksBy.match(/(.*) \((.*)\)/).slice(1, 3) : ["--", "--"];
                                return (
                                    <tr key={raiseClaimRemarksId}>
                                        <td>{formatDate(remarksDate) || "--"}</td>
                                        <td>{commenter || "--"}</td>
                                        <td>{role || "--"}</td>
                                        <td>{remarks || "--"}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table> : <p className='no-data text-center'>No Comments Found</p>}
                <div className='fieldArrayColumnUl_outer' style={{ background: "rgb(239,239,239)" }}>
                    <textarea
                        name="newComment"
                        placeholder="Enter Your Comments Here.."
                        className="form-control"
                        value={newComment}
                        onChange={(event) => setNewComment(event.target.value)}
                    />
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <button type="button" className="btn btn-primary mt-2" disabled={!newComment.trim() || isSubmitted || claimDetails?.claimStatus === "Withdrawn"} onClick={addComments}>
                            Add Comments
                        </button>
                    </div>
                </div>
            </div> : <Loading />
    )
}

export default InfoRaiseClaimModal
